import classes from './PanelWrapper.module.css'

const PanelWrapper = (props) => {
    return <div className={classes.panelWrapper}>{props.children}</div>
}

export default PanelWrapper;